import { useState, useRef } from 'react';
import KeySelector from '../../components/key-selector/KeySelector'
import { GUITAR_TUNINGS } from '../../data/tunings';
import { MUSICAL_KEYS } from '../../data/keys';
import CapoSelector from '../../components/capo-selector/CapoSelector';
import TuningSelector from '../../components/tuning-selector/TuningSelector';
import { useMediaQuery } from '@mui/material';
import Guitar from '../../components/guitar(new)/Guitar';
import { scaleData } from './scales';
import './scaleViewer.scss'
import ScaleDegreeChart from '../../components/scale-degree-chart/ScaleDegreeChart';
import ScaleExportTemplate from '../../components/scale-export-template/ScaleExportTemplate';
import { exportScaleToPDF, generateScaleFilename } from '../../utils/exportScale';
import { Button } from '@mui/joy';
import DownloadIcon from '@mui/icons-material/Download';

const ScaleViewer = () => {
    const [tuning, setTuning] = useState(GUITAR_TUNINGS[0].notes);
    const [viewerKey, setViewerKey] = useState(MUSICAL_KEYS.find(k => k.root === 'C'));
    const [capo, setCapo] = useState(null);
    const [isExporting, setIsExporting] = useState(false);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const exportRef = useRef(null);

    const currentScale = scaleData[viewerKey.type];

    const handleExportPDF = async () => {
        if (!exportRef.current) return;

        setIsExporting(true);
        try {
            const filename = generateScaleFilename(viewerKey);
            await exportScaleToPDF(exportRef.current, filename);
        } catch (error) {
            console.error('Failed to export PDF:', error);
            alert('Failed to export PDF. Please try again.');
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <div className='scale-viewer'>
              <h1>Scale Viewer</h1>
            <div>
                <div className='settings-container'>
                    <div className='settings-container__child'>
                        <TuningSelector tuning={tuning} setTuning={setTuning} />
                        <CapoSelector capo={capo} setCapo={setCapo} />
                    </div>
                    <div className='settings-container__child'> 
                        <Button onClick={handleExportPDF} disabled={isExporting} startDecorator={<DownloadIcon />}>{isExporting ? 'Exporting...' : 'Download Scale'}</Button>
                        {/* <IconButton variant='solid' color='primary'>
                            <SettingsIcon />
                        </IconButton> */}
                    </div>
                </div>
                <Guitar vertical={isMobile} tuning={tuning} capo={capo} activeNotes={viewerKey.notes} updateNotes={setViewerKey} clickToAddAndRemove={false}  />
                <ScaleDegreeChart scaleNotes={viewerKey.notes} />
                <KeySelector selectedKey={viewerKey} setKey={setViewerKey} />
            </div>
            {/* POST MVP */}
            {/* <div className='scale-viewer__info'>
                <h3 className='scale-viewer__info-header'>{`How is the ${viewerKey.type} Scale Made?`}</h3>
                {currentScale?.paragraphs[0] && <p>{currentScale.paragraphs[0]}</p>}
                <p className='bold'>{currentScale?.pattern}</p>
                {currentScale?.paragraphs.slice(1).map((text, index) => (
                    <p key={index}>{text}</p>
                ))}
                {currentScale?.image && <img src={currentScale.image} alt={`${viewerKey.type} scale diagram`} />}
            </div> */}

            <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                <ScaleExportTemplate
                    ref={exportRef}
                    viewerKey={viewerKey}
                    tuning={tuning}
                    capo={capo}
                    watermarkText="ezguitarscales.com"
                />
            </div>
        </div>
    )
}

export default ScaleViewer